// @ts-nocheck

import { unCamelCase } from "../../utilities/unCamelCase";
import { fetchIgAsTriggers } from "../../services/helpers/QueryBuilderHelper";
import {
  prepareBoolean,
  reverseParseBoolean,
} from "../../app/action-block/filter/utils";

export const prepareQbState = (state: any) => ({
  ...state,
  nodes: state.nodes.map((node: any) => ({
    ...node,
    properties: node.properties?.map((p: any) => prepareBoolean(p)).flat() ?? [],
  })),
});

export const reRenderQbNodes = (nodes: any[]) =>
  nodes.map((node: any) => ({
    ...node,
    properties: node.properties?.map((p: any) => reverseParseBoolean(p)).flat() ?? [],
  }));

export const extractHeaderAndSubHeader = (builderState: any) => {
  const node = builderState.nodes[0];
  let header = unCamelCase(node.metas[0].value);
  let subHeader = "";
  node.properties.forEach((property, index) => {
    if (
      property.dataType === "specificStory" ||
      property.dataType === "specificReel" ||
      property.dataType === "specificPost" ||
      property.dataType === "anyIg" ||
      property.dataType === "anyAd"
    )
      return;
    let str = "";
    // Todo: remove this check once campaign fixes this
    if (
      !!node.metas.length &&
      (node.metas[0].value === "abandonedAProduct" ||
        node.metas[0].value === "productViewed") &&
      property.name === "productId"
    ) {
      str += unCamelCase("productName");
    } else {
      str += unCamelCase(property.name);
    }

    str += property.operator ? " " + unCamelCase(property.operator) : "";
    if (Array.isArray(property.value)) {
      property.value.forEach((v, i) => {
        if (typeof v === "undefined") return;
        if (typeof v.name === "undefined") {
          str += " " + v + `${i === property.value.length - 1 ? "" : ","}`;
        } else {
          str += " " + v.name + `${i === property.value.length - 1 ? "" : ","}`;
        }
      });
    } else {
      str += property.value ? " " + property.value : "";
    }
    if (node.type === "IG_TRIGGER" && index === 0) {
      str += `${index === node.properties.length - 2 ? "" : " , "}`;
    } else {
      if (node.properties.find((item) => item.dataType === "anyAd")) {
        // DO NOTHING
      } else {
        str += `${index === node.properties.length - 1 ? "" : " , "}`;
      }
    }
    subHeader += str;
  });
  return { header, subHeader, id: node._id };
};

export const extractIgMedia = (builderState: any) => {
  const node = builderState.nodes[0];
  let media = [];
  let mediaType = "";
  let tag = "";
  node.properties.forEach((property, index) => {
    if (
      property.dataType === "specificStory" ||
      property.dataType === "specificReel" ||
      property.dataType === "specificPost"
    ) {
      mediaType = extractMediaType(property.name);
      property.value.forEach((v) => {
        media.push(v);
      });
      tag = `${media.length} ${mediaType}(s)`;
    } else if (property.dataType === "anyIg" || property.dataType === "anyAd") {
      tag = unCamelCase(property.name);
    }
  });
  return { media, mediaType, tag };
};

export const extractMediaType = (name: string) => {
  if (name === "specificPosts") {
    return "post";
  } else if (name === "specificReels") {
    return "reel";
  } else {
    return "story";
  }
};

export const eventsTriggerApiHandler = async (
  payload: BaseQueryBuilderPayload<
    | undefined
    | { triggerName: string }
    | { triggerName: string; propertyName: string }
  >,
  storeId: string,
  instagramId: string
) => {
  if (!payload.query) {
    const response = await fetchIgAsTriggers({
      storeId: storeId,
      instagramId,
    });

    if (response.data) {
      return response.data;
    }
  }
  if (payload.query?.triggerName && !payload.query?.propertyName) {
    const response = await fetchIgAsTriggers({
      storeId: storeId,
      instagramId,
      ...payload,
    });
    if (response.data) {
      return response.data;
    }
  }
  if (payload.query?.triggerName && payload.query?.propertyName) {
    const response = await fetchIgAsTriggers({
      storeId: storeId,
      instagramId,
      ...payload,
    });
    if (response.data && response.data.data) {
      return response.data;
    }
  }
  return { status: 200 };
};
